import { VType } from 'nerv-shared'
export function createVoid () {
  return {
    dom: null,
    vtype: VType.Void
  }
}
